import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { catchAsync, IS_SUCCESS_RESPONSE } from "src/helpers";
import { getViewOABankingReport } from "src/services/requests/Report";

import { ChevronLeft } from "lucide-react";
import { DataTable } from "src/modules/Report/ViewDetails/TableComponentOADetails/data-table";
import { columns } from "src/modules/Report/ViewDetails/TableComponentOADetails/columns";
interface DateProps {
  start_date: string;
  end_date: string;
}
const OaViewDetailMain = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState<boolean>(false);
  const [dataExistingTODSlab, setDataExistingTODSlab] = useState<any[]>([]);
  const [dataCommisionApprTODSlab, setDataCommisionApprTODSlab] = useState<any[]>([]);
  const [date, setDate] = useState<DateProps>({ start_date: "", end_date: "" });
  const handleOAConsumptionRequest = catchAsync(
    async (_id: any) => {
      setisLoading(true);
      return await getViewOABankingReport(_id);
    },
    (result: any) => {
      if (IS_SUCCESS_RESPONSE(result)) {
        setDataCommisionApprTODSlab(result?.data[0]?.commisionApprTODSlab);
        setDataExistingTODSlab(result?.data[0]?.existingTODSlab);
        setDate(result?.data[0]?.date);
        setisLoading(false);
      }
    },
    () => {
      setisLoading(false);
    }
  );

  useEffect(() => {
    if (id) {
      handleOAConsumptionRequest(id);
    } else return;

    return () => {};
  }, [id]);

  return (
    <div className="w-full space-y-6 p-4">
      <div className="flex space-x-2 items-center justify-between text-primary">
        <div className="flex items-center space-x-2">
          <div title="Back">
            <ChevronLeft className="cursor-pointer" onClick={() => navigate("/report")} />
          </div>
          <h2 className="text-lg font-semibold">View Details</h2>
        </div>

        <div>
          {date?.end_date || date?.start_date ? (
            <div className="flex items-start space-x-1 text-sm text-primary font-medium">
              <span>Date :</span>
              <span>{date?.start_date}</span>
              <span>-</span>
              <span>{date?.end_date}</span>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>

      <h2 className="text-base font-semibold text-primary ">Existing TOD Slab</h2>
      <DataTable columns={columns} data={dataExistingTODSlab || []} isLoading={isLoading} />
      <hr className="border border-gray-600" />
      <h2 className="text-base font-semibold text-primary ">Commision Approved TOD Slab</h2>
      <DataTable columns={columns} data={dataCommisionApprTODSlab || []} isLoading={isLoading} />
    </div>
  );
};

export default OaViewDetailMain;
